import "./SignUp.css";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AccountMenu } from "./Component/AccountMenu";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import { styled } from "@mui/material/styles";

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { API_DOMAIN_URL } from "./Common";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {/*{"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}*/}
    </Typography>
  );
}

const theme = createTheme();

export function SignUp() {
  const navigate = useNavigate();

  // フォームの入力状態
  // 0: 入力画面, 1: 確認画面, 2: 完了画面
  const [formStatus, setFormStatus] = useState(0);

  // フォームで入力されたデータ
  const [inputData, setInputData] = useState();

  const validationSchema = Yup.object().shape({
    UserName: Yup.string().required("ユーザーIDを入力してください"),
    CompanyName: Yup.string().required("会社名を入力してください"),
    Sei: Yup.string().required("姓を入力してください"),
    Mei: Yup.string().required("名を入力してください"),
    SeiFurigana: Yup.string().required("ふりがな（姓）を入力してください"),
    MeiFurigana: Yup.string().required("ふりがな（名）を入力してください"),
    MailAddress: Yup.string()
      .required("E-mailを入力してください")
      .email("E-mailが無効です"),
    MailAddressConfirm: Yup.string()
      .required("確認用E-mailを入力して下さい")
      .oneOf([Yup.ref("MailAddress"), null], "上記のE-mailと違います"),
    SisetsuName: Yup.string(),
    Gyousyu: Yup.string(),
    ZipCode: Yup.string().required("郵便番号を入力してください"),
    Address1: Yup.string().required("住所１を入力してください"),
    Address2: Yup.string(),
    PhoneNumber: Yup.string().required("電話番号を入力してください"),
    Fax: Yup.string(),
    YakusyokuName: Yup.string(),
    Sikaku: Yup.string(),

    SeikyuCompanyName: Yup.string(),
    SeikyuSei: Yup.string(),
    SeikyuMei: Yup.string(),
    SeikyuSeiFurigana: Yup.string(),
    SeikyuMeiFurigana: Yup.string(),
    SeikyuZipCode: Yup.string(),
    SeikyuAddress1: Yup.string(),
    SeikyuAddress2: Yup.string(),
    SeikyuPhoneNumber: Yup.string(),
    SeikyuFax: Yup.string(),

    Bikou: Yup.string(),

    AgreeTerms: Yup.bool().oneOf([true], "規約への同意が必要です"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  // フォームに入力されたデータをチェックして
  // 確認画面へ遷移
  const onSubmit = (data) => {
    if (
      data.UserName == undefined ||
      data.CompanyName == undefined ||
      data.Sei == undefined ||
      data.Mei == undefined ||
      data.SeiFurigana == undefined ||
      data.MeiFurigana == undefined ||
      data.MailAddress == undefined ||
      data.ZipCode == undefined ||
      data.Address1 == undefined ||
      data.PhoneNumber == undefined
    ) {
      console.log("Invalid Input Value");
      return;
    }

    data.SeikyuType = seikyuType;

    setFormStatus(1);
    setInputData(data);
  };

  const sendData = (data) => {
    if (!data || !data.UserName) {
      return;
    }

    // update db
    const bodyString = JSON.stringify(data);
    //console.log(bodyString);

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/CreateReportUserInfo?code=${code}&UserName=${data.UserName}`;
    //console.log(url);
    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          setFormStatus(2);
          //navigate("/SignIn");
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  const toSignIn = () => {
    navigate("/SignIn");
  };

  // エラーモーダル
  const [open, setOpen] = React.useState(false);
  const errorModalOpen = () => {
    setOpen(true);
  };
  const errorModalClose = () => {
    setOpen(false);
  };

  // 請求先ラジオボタン
  const [seikyuType, setSeikyuType] = React.useState(0);

  const handleChange = (event) => {
    setSeikyuType(event.target.value);
  };

  // 入力画面
  const inputForm = (
    <>
      <Typography component="h1" variant="h5">
        ハカロ-Hacaro- マイページサービス申し込み
      </Typography>
      <Typography variant="subtitle2" sx={{ mt: 3, mb: 1 }}>
        <br></br>～お申込みにあたり～<br></br>
      </Typography>
      <Typography variant="caption">
        この入力フォームよりお申し込みのお客様は、ご利用初月はお試し期間として無料でお使いいただけます。無料期間終了時はメールにてご案内致します。
        <br></br>
        ※アプリから新規登録がまだの方は、先にスマートフォンにアプリをダウンロードしていただき、新規登録を行ってください。
        <br></br>
        お申し込みする『お客様の情報』と『ご請求先情報』をご入力ください。必ずプライバシーポリシーおよびハカロマイページサービス
        利用規約をお読みになり、[規約に同意する]をチェックして[確認画面へ]ボタンを押してください。
        <br></br>
        お申込みが完了しましたら、「完了メール」にて弊社スタッフよりお申込み内容の確認をさせて頂きます。
        <br></br>
        ※受信拒否の設定をされている場合は、ドメイン受信指定「@hacaro.jp」を設定してください。
        <br></br>
      </Typography>
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ mt: 5 }}
      >
        <Grid container spacing={1}>
          <Grid item md={12}>
            <Typography variant="h6" align="left">
              お客様情報
            </Typography>
          </Grid>
          <Grid item md={12}>
            <TextField
              name="UserName"
              required
              fullWidth
              size="small"
              id="UserName"
              label="Hacaro-ハカロ- のユーザーID（半角英数字）"
              {...register("UserName")}
              error={errors.UserName ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.UserName?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              size="small"
              id="CompanyName"
              label="会社名"
              name="CompanyName"
              {...register("CompanyName")}
              error={errors.CompanyName ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.CompanyName?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              id="Sisetsu"
              label="施設名・店舗名"
              name="SisetsuName"
              {...register("SisetsuName")}
              error={errors.SisetsuName ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.SisetsuName?.message}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              fullWidth
              size="small"
              id="Sei"
              label="担当者（姓）"
              name="Sei"
              {...register("Sei")}
              error={errors.Sei ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Sei?.message}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              size="small"
              fullWidth
              name="Mei"
              label="担当者（名）"
              id="Mei"
              {...register("Mei")}
              error={errors.Mei ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Mei?.message}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              size="small"
              fullWidth
              name="SeiFurigana"
              label="ふりがな（姓）"
              id="SeiFurigana"
              {...register("SeiFurigana")}
              error={errors.SeiFurigana ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.sei?.SeiFurigana}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              size="small"
              fullWidth
              name="MeiFurigana"
              label="ふりがな（名）"
              id="MeiFurigana"
              {...register("MeiFurigana")}
              error={errors.MeiFurigana ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.MeiFurigana?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              size="small"
              fullWidth
              name="MailAddress"
              label="E-mail"
              type="email"
              id="MailAddress"
              {...register("MailAddress")}
              error={errors.MailAddress ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.MailAddress?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              size="small"
              fullWidth
              name="MailAddressConfirm"
              label="確認用E-mail"
              type="email"
              id="MailAddressConfirm"
              {...register("MailAddressConfirm")}
              error={errors.MailAddressConfirm ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.MailAddressConfirm?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              name="Gyousyu"
              label="業種"
              id="Gyousyu"
              {...register("Gyousyu")}
              error={errors.Gyousyu ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Gyousyu?.message}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <TextField
              required
              size="small"
              fullWidth
              name="ZipCode"
              label="郵便番号"
              id="ZipCode"
              {...register("ZipCode")}
              error={errors.ZipCode ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.ZipCode?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              size="small"
              fullWidth
              name="Address1"
              label="住所1"
              id="Address1"
              {...register("Address1")}
              error={errors.Address1 ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Address1?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              name="Address2"
              label="住所2"
              id="Address2"
              {...register("Address2")}
              error={errors.Address2 ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Address2?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              size="small"
              fullWidth
              name="PhoneNumber"
              label="電話（携帯電話可）"
              id="PhoneNumber"
              type="tel"
              {...register("PhoneNumber")}
              error={errors.PhoneNumber ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.PhoneNumber?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              name="Fax"
              label="Fax"
              id="Fax"
              type="tel"
              {...register("Fax")}
              error={errors.Fax ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Fax?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              name="YakusyokuName"
              label="役職"
              id="YakusyokuName"
              {...register("YakusyokuName")}
              error={errors.YakusyokuName ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.YakusyokuName?.message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              name="Sikaku"
              label="資格"
              id="Sikaku"
              {...register("Sikaku")}
              error={errors.Sikaku ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Sikaku?.message}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          <Grid item md={12}>
            <Typography variant="h6" align="left">
              ご請求先情報
            </Typography>
          </Grid>
          <Grid item md={12}>
            <FormLabel id="demo-controlled-radio-buttons-group">
              ※請求先
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              id="SeikyuType"
              value={seikyuType}
              onChange={handleChange}
            >
              <FormControlLabel
                value="0"
                control={<Radio />}
                label="上記お客様と同じ"
              />
              <FormControlLabel
                value="1"
                control={<Radio />}
                label="下記住所を請求する"
              />
            </RadioGroup>
          </Grid>

          {seikyuType == 0 ? (
            ""
          ) : (
            <>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  id="SeikyuCompanyName"
                  label="会社名"
                  name="SeikyuCompanyName"
                  {...register("SeikyuCompanyName")}
                  error={errors.SeikyuCompanyName ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuCompanyName?.message}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size="small"
                  id="SeikyuSei"
                  label="担当者（姓）"
                  name="SeikyuSei"
                  {...register("SeikyuSei")}
                  error={errors.SeikyuSei ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuSei?.message}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuMei"
                  label="担当者（名）"
                  id="SeikyuMei"
                  {...register("SeikyuMei")}
                  error={errors.SeikyuMei ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuMei?.message}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuSeiFurigana"
                  label="ふりがな（姓）"
                  id="SeikyuSeiFurigana"
                  {...register("SeikyuSeiFurigana")}
                  error={errors.SeikyuSeiFurigana ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.sei?.SeikyuSeiFurigana}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuMeiFurigana"
                  label="ふりがな（名）"
                  id="SeikyuMeiFurigana"
                  {...register("SeikyuMeiFurigana")}
                  error={errors.SeikyuMeiFurigana ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuMeiFurigana?.message}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuZipCode"
                  label="郵便番号"
                  id="SeikyuZipCode"
                  {...register("SeikyuZipCode")}
                  error={errors.SeikyuZipCode ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuZipCode?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuAddress1"
                  label="住所1"
                  id="SeikyuAddress1"
                  {...register("SeikyuAddress1")}
                  error={errors.SeikyuAddress1 ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuAddress1?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuAddress2"
                  label="住所2"
                  id="SeikyuAddress2"
                  {...register("SeikyuAddress2")}
                  error={errors.SeikyuAddress2 ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuAddress2?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuPhoneNumber"
                  label="電話（携帯電話可）"
                  id="SeikyuPhoneNumber"
                  type="tel"
                  {...register("SeikyuPhoneNumber")}
                  error={errors.SeikyuPhoneNumber ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuPhoneNumber?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  name="SeikyuFax"
                  label="Fax"
                  id="SeikyuFax"
                  type="tel"
                  {...register("SeikyuFax")}
                  error={errors.SeikyuFax ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.SeikyuFax?.message}
                </Typography>
              </Grid>
            </>
          )}

          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid item md={12}>
              <Typography variant="h6" align="left">
                その他
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                name="Bikou"
                label="備考"
                id="Bikou"
                {...register("Bikou")}
                error={errors.Bikou ? true : false}
              />
              <Typography variant="inherit" color="textSecondary">
                {errors.Bikou?.message}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="caption">
              <div align="left">
                <a
                  href="https://hacaro.jp/privacy-policy.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  プライバシーポリシー
                </a>
                および
                <a
                  href="https://hacaro.jp/terms-mp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  ハカロマイページサービス 利用規約
                </a>
                をご確認の上「規約に同意する」をチェックして、「確認画面へ」ボタンを押してください。
              </div>
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  required
                  color="primary"
                  {...register("AgreeTerms")}
                  error={errors.AgreeTerms ? true : false}
                />
              }
              label="規約に同意する"
            />
            <Typography variant="inherit" color="red">
              {errors.AgreeTerms?.message}
            </Typography>
          </Grid>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          確認画面へ
        </Button>
        {/*<Grid container justifyContent="flex-end">
          <Grid item>
            <Link href="#" variant="body2">
              {language.SignUp_AlreadyHaveAnAccount}
            </Link>
            </Grid>
        </Grid>*/}
      </Box>
    </>
  );

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  // 確認画面
  const confirmForm = (
    <>
      <Typography component="h1" variant="h5">
        確認画面
      </Typography>
      <TableContainer component={Paper} align="center" sx={{ mt: 3 }}>
        <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
          <TableHead>
            <StyledTableRow>
              <TableCell align="left" colSpan={2}>
                お客様情報
              </TableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                ログインID
              </TableCell>
              <TableCell align="left">
                {inputData != undefined ? inputData.UserName : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                会社名
              </TableCell>
              <TableCell align="left">
                {inputData != undefined ? inputData.CompanyName : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                E-mail
              </TableCell>
              <TableCell align="left">
                {inputData != undefined ? inputData.MailAddress : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                施設名
              </TableCell>
              <TableCell align="left">
                {inputData != undefined && inputData.SisetsuName != undefined
                  ? inputData.SisetsuName
                  : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                業種
              </TableCell>
              <TableCell align="left">
                {inputData != undefined && inputData.Gyousyu != undefined
                  ? inputData.Gyousyu
                  : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                郵便番号
              </TableCell>
              <TableCell align="left">
                {inputData != undefined ? inputData.ZipCode : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                住所１
              </TableCell>
              <TableCell align="left">
                {inputData != undefined ? inputData.Address1 : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                住所２
              </TableCell>
              <TableCell align="left">
                {inputData != undefined && inputData.Address2
                  ? inputData.Address2
                  : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                電話番号
              </TableCell>
              <TableCell align="left">
                {inputData != undefined ? inputData.PhoneNumber : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Fax
              </TableCell>
              <TableCell align="left">
                {inputData != undefined && inputData.Fax != undefined
                  ? inputData.Fax
                  : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                ご担当者名
              </TableCell>
              <TableCell align="left">
                {inputData != undefined ? inputData.Sei + inputData.Mei : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                ふりがな
              </TableCell>
              <TableCell align="left">
                {inputData != undefined
                  ? inputData.SeiFurigana + inputData.MeiFurigana
                  : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                役職
              </TableCell>
              <TableCell align="left">
                {inputData != undefined && inputData.YakusyokuName != undefined
                  ? inputData.YakusyokuName
                  : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                保有資格
              </TableCell>
              <TableCell align="left">
                {inputData != undefined && inputData.Sikaku != undefined
                  ? inputData.Sikaku
                  : ""}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} align="center">
        <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
          <TableHead>
            <StyledTableRow>
              <TableCell align="left" colSpan={2} color="red">
                ご請求先情報
              </TableCell>
            </StyledTableRow>
          </TableHead>

          <TableBody>
            {inputData != undefined &&
            inputData.SeikyuType != undefined &&
            inputData.SeikyuType == 0 ? (
              <>
                <TableRow>
                  <TableCell component="th" scope="row"></TableCell>
                  <TableCell align="left">上記のお客様情報と同じ</TableCell>
                </TableRow>
              </>
            ) : (
              <>
                <TableRow>
                  <TableCell component="th" scope="row">
                    会社名
                  </TableCell>
                  <TableCell align="left">
                    {inputData && inputData.SeikyuCompanyName
                      ? inputData.SeikyuCompanyName
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    郵便番号
                  </TableCell>
                  <TableCell align="left">
                    {inputData && inputData.SeikyuZipCode
                      ? inputData.SeikyuZipCode
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    住所１
                  </TableCell>
                  <TableCell align="left">
                    {inputData && inputData.SeikyuAddress1
                      ? inputData.SeikyuAddress1
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    住所２
                  </TableCell>
                  <TableCell align="left">
                    {inputData && inputData.SeikyuAddress2
                      ? inputData.SeikyuAddress2
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    電話番号
                  </TableCell>
                  <TableCell align="left">
                    {inputData && inputData.SeikyuPhoneNumber
                      ? inputData.SeikyuPhoneNumber
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Fax
                  </TableCell>
                  <TableCell align="left">
                    {inputData && inputData.SeikyuFax
                      ? inputData.SeikyuFax
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    ご担当者名
                  </TableCell>
                  <TableCell align="left">
                    {inputData != undefined &&
                    inputData.SeikyuSei != undefined &&
                    inputData.SeikyuMei != undefined
                      ? inputData.SeikyuSei + inputData.SeikyuMei
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    ふりがな
                  </TableCell>
                  <TableCell align="left">
                    {inputData != undefined
                      ? inputData.SeikyuSeiFurigana +
                        inputData.SeikyuMeiFurigana
                      : ""}
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} align="center">
        <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
          <TableHead>
            <StyledTableRow>
              <TableCell align="left" colSpan={2}>
                その他
              </TableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                備考
              </TableCell>
              <TableCell align="left">
                {inputData && inputData.Bikou ? inputData.Bikou : ""}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        onClick={() => sendData(inputData)}
      >
        登録
      </Button>
    </>
  );

  // 完了画面
  const completeForm = (
    <>
      <Typography component="h1" variant="h5">
        登録完了
      </Typography>
      <Typography sx={{ mt: 3 }} variant="body2">
        登録が完了しました。
      </Typography>
      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        onClick={toSignIn}
      >
        ログイン画面へ
      </Button>
    </>
  );

  return (
    <ThemeProvider theme={theme}>
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "#d33320" }}>
            <LockOutlinedIcon />
          </Avatar>

          {formStatus == 0 ? inputForm : null}
          {formStatus == 1 ? confirmForm : null}
          {formStatus == 2 ? completeForm : null}
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
      <Dialog
        open={open}
        onClose={errorModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">入力エラー</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ユーザーIDが正しいか確認して下さい。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={errorModalClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
